module.exports = __webpack_public_path__ + "static/media/likes.5ebbd935.svg";